import axios from "axios";
import React, { useEffect, useState } from "react";
import url from "../../../Utility/URL/url";
import { useParams } from "react-router-dom";
import ServiceInformation from "../ServiceInformation";
import Loader from "../../../Utility/loader/Loader";
import FourZeroFour from "../../../Utility/ErrorPages/FourZeroFour/FourZeroFour";

// ✅ Shared API function (can be reused in TextQuery.jsx)
export function getAdvisorDetails(username, id) {
  console.log(`[API CALLED] from ${window.location.pathname}`, { username, id });

  return axios.get(
    `${url.GET_SERVICE_BY_USERNAME_AND_PLATFORMSERVICEID}${id}?username=${username}`
  );
}

function SearchServiceFromDB() {
  const { username, id } = useParams();
  const [dbInformation, setDbInformation] = useState();
   let advisorInfo = {};
  let serviceInformation = {};
  const [loader, setLoader] = useState(true);
  const [fourZeroFour, setFourZeroFour] = useState(false);
  

  useEffect(() => {
    const advisorDetails = async () => {
      try {
        const details = await getAdvisorDetails(username, id);
        const { data } = details;
        setDbInformation(() => data);
        setLoader(false);
      } catch (error) {
        console.error("API Error in SearchServiceFromDB →", error);
        setFourZeroFour(true);
        setLoader(false);
      }
    };

    advisorDetails();
  }, [username, id]);

  if (dbInformation) {
    const { userReviews, serviceData, availability, profileData } =
      dbInformation;

    advisorInfo.userReviews = userReviews;
    advisorInfo.availability = availability;
    advisorInfo.profileData = profileData;
    serviceInformation = serviceData;
  }

   return loader ? (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <Loader />
    </div>
  ) : fourZeroFour ? (
    <FourZeroFour />
  ) : (
    <ServiceInformation
      advisorInfo={advisorInfo}
      serviceInformation={serviceInformation}
    />
  );
}
  

  // return null;


export default SearchServiceFromDB;
